if (!customElements.get('bp-editorial-gallery')) {
  customElements.define('bp-editorial-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const viewport = this.querySelector('.bp-eg__viewport');
      const slides = Array.from(this.querySelectorAll('.bp-eg__slide'));
      const thumbs = Array.from(this.querySelectorAll('.bp-eg__thumb'));
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      const count = this.querySelector('[data-gallery-count]');
      const dialog = this.querySelector('dialog');
      const fullImage = this.querySelector('.bp-eg__full');
      let current = 0;
      let viewportWidth = viewport.clientWidth;
      if (!slides.length) return;

      const update = () => {
        const width = viewport.clientWidth;
        if (width > 0 && width === viewportWidth) {
          current = Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / width)));
        }
        thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === current)));
        previous.disabled = current === 0;
        next.disabled = current === slides.length - 1;
        count.textContent = `${current + 1} / ${slides.length}`;
      };
      const goTo = (index) => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        viewport.scrollTo({ left: viewport.clientWidth * target });
      };
      viewport.addEventListener('scroll', update, { ...options, passive: true });
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      previous.addEventListener('click', () => goTo(current - 1), options);
      next.addEventListener('click', () => goTo(current + 1), options);
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goTo(index), options));
      slides.forEach((slide) => slide.querySelector('button').addEventListener('click', () => {
        const image = slide.querySelector('img');
        fullImage.src = image.src;
        fullImage.alt = image.alt;
        dialog.showModal();
      }, options));
      this.querySelector('.bp-eg__close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        const width = viewport.clientWidth;
        if (width === 0) return;
        viewportWidth = width;
        viewport.scrollTo({ left: current * width, behavior: 'instant' });
        update();
      });
      this.resizeObserver.observe(viewport);
      this.querySelector('.bp-eg__controls').hidden = false;
      this.querySelector('.bp-eg__thumbs').hidden = false;
      update();
    }
    disconnectedCallback() {
      this.controller.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
